import { useState } from "react";
import { aenderePasswort } from "../api.js";

export function PasswortAendern({
  erzwungen,
  beiErfolg,
}: {
  erzwungen: boolean;
  beiErfolg: () => void;
}) {
  const [alt, setAlt] = useState("");
  const [neu, setNeu] = useState("");
  const [wdh, setWdh] = useState("");
  const [fehler, setFehler] = useState<string | null>(null);
  const [laeuft, setLaeuft] = useState(false);

  async function absenden(e: React.FormEvent) {
    e.preventDefault();
    setFehler(null);
    if (neu !== wdh) return setFehler("Die beiden neuen Passwörter stimmen nicht überein.");

    if (neu.length < 12) return setFehler("Das neue Passwort muss mindestens 12 Zeichen haben.");

    setLaeuft(true);
    try {
      // Beide Werte werden im Browser gestreckt; Klartext geht nie raus.
      await aenderePasswort(alt, neu);
      beiErfolg();
    } catch (err) {
      setFehler(err instanceof Error ? err.message : "Änderung fehlgeschlagen.");
    } finally {
      setLaeuft(false);
    }
  }

  return (
    <section className="karte" style={{ maxWidth: 460 }}>
      <h2>Passwort ändern</h2>

      {erzwungen && (
        <div className="meldung hinweis">
          Bitte vergeben Sie ein eigenes Passwort, bevor Sie fortfahren.
        </div>
      )}
      {fehler && (
        <div className="meldung fehler" role="alert">
          {fehler}
        </div>
      )}

      <form onSubmit={absenden}>
        <div className="feld">
          <label htmlFor="alt">Aktuelles Passwort</label>
          <input
            id="alt"
            type="password"
            autoComplete="current-password"
            required
            maxLength={128}
            value={alt}
            onChange={(e) => setAlt(e.target.value)}
          />
        </div>
        <div className="feld">
          <label htmlFor="neu">Neues Passwort</label>
          <input
            id="neu"
            type="password"
            autoComplete="new-password"
            required
            minLength={12}
            maxLength={128}
            value={neu}
            onChange={(e) => setNeu(e.target.value)}
          />
          <p className="hinweistext">
            Mindestens 12 Zeichen. Länge zählt mehr als Sonderzeichen — eine Folge aus vier
            zufälligen Wörtern ist eine gute Wahl.
          </p>
        </div>
        <div className="feld">
          <label htmlFor="wdh">Neues Passwort wiederholen</label>
          <input
            id="wdh"
            type="password"
            autoComplete="new-password"
            required
            maxLength={128}
            value={wdh}
            onChange={(e) => setWdh(e.target.value)}
          />
        </div>

        <button className="knopf" type="submit" disabled={laeuft}>
          {laeuft ? "Wird geändert …" : "Passwort ändern"}
        </button>
        <p className="hinweistext">
          Alle anderen aktiven Sitzungen werden dabei beendet.
        </p>
      </form>
    </section>
  );
}
